var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("upload-file-select", {
        attrs: { isPartOfForm: "" },
        on: { sendFile: _vm.addFileOrUpload }
      }),
      _vm._v(" "),
      _vm.value && _vm.value.length
        ? _c(
            "div",
            { staticClass: "mt-4" },
            [
              _c("paginated-table", {
                attrs: {
                  fields: _vm.tableFields,
                  items: _vm.value,
                  showCaption: false
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell(icon)",
                      fn: function(data) {
                        return [
                          data.item.data.fileType === "link"
                            ? _c("b-icon-link45deg", {
                                attrs: { variant: "primary" }
                              })
                            : data.item.data.fileType.includes("image")
                            ? _c("b-icon-image", {
                                attrs: { variant: "primary" }
                              })
                            : data.item.data.fileType.includes("pdf")
                            ? _c("b-icon-file-earmark-pdf", {
                                attrs: { variant: "primary" }
                              })
                            : data.item.data.fileType.includes("application")
                            ? _c("b-icon-file-earmark-text", {
                                attrs: { variant: "primary" }
                              })
                            : _c("b-icon-folder", {
                                attrs: { variant: "primary" }
                              })
                        ]
                      }
                    },
                    {
                      key: "cell(fileName)",
                      fn: function(data) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "clickable",
                              on: {
                                click: function($event) {
                                  return _vm.openFile(data.item.data.url)
                                }
                              }
                            },
                            [_vm._v(_vm._s(data.item.data.name))]
                          )
                        ]
                      }
                    },
                    {
                      key: "cell(remove)",
                      fn: function(data) {
                        return [
                          _c("b-icon-trash", {
                            staticClass: "clickable",
                            attrs: { variant: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.removeFile(data.index)
                              }
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  589695012
                )
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32b37798", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32b37798","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/forms/UploadFileGroupForm.vue
// module id = 2969
// module chunks = 2 5 14